(() => {
  const TARGET_LOCALE = 'es';

  function forceSpanishLocale() {
    const lang = (document.documentElement.lang || '').toLowerCase();
    if (lang === 'es' || lang.startsWith('es-')) return;
    if (sessionStorage.getItem('veoness_es_locale_attempted') === '1') return;

    sessionStorage.setItem('veoness_es_locale_attempted', '1');
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.style.display = 'none';

    const fields = {
      form_type: 'localization',
      utf8: '✓',
      language_code: TARGET_LOCALE,
      return_to: window.location.pathname + window.location.search + window.location.hash
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.documentElement.appendChild(form);
    form.submit();
  }

  const exactText = new Map([
    ['REAL CUSTOMER STORIES', 'HISTORIAS REALES DE CLIENTES'],
    ['What Our Customers Say', 'Lo que dicen nuestros clientes'],
    ['Verified Purchase', 'Compra verificada'],
    ['Product', 'Producto'],
    ['Night Reset Pillow Mist', 'Bruma para Almohada Night Reset'],
    ['Barrier Body Cream', 'Crema Corporal Barrier'],
    ['Cooling Recovery Roll-On', 'Roll-On Recovery Refrescante'],
    ['The Evening Routine Set', 'Set Rutina de Noche'],
    ['The lavender pillow mist has become the cue that my day is done. It feels simple, but it really changes the mood of my evening.', 'La bruma de lavanda para la almohada se ha convertido en la señal de que mi día terminó. Es un gesto sencillo, pero cambia por completo el ambiente de mi noche.'],
    ['I keep the body cream in my bathroom and reach for it without thinking. It absorbs quickly and makes my routine feel much more put together.', 'Guardo la crema corporal en el baño y la uso casi sin pensarlo. Se absorbe rápido y hace que mi rutina se sienta mucho más completa.'],
    ['The roll-on is now always in my gym bag. Cooling, clean and so easy to use exactly where I need it.', 'El roll-on ya siempre está en mi bolsa del gimnasio. Es refrescante, limpio y muy fácil de aplicar justo donde lo necesito.'],
    ['The evening set looks beautiful on my nightstand and makes winding down feel intentional instead of rushed.', 'El set de noche queda precioso en mi mesita y hace que bajar el ritmo al final del día se sienta como un ritual, no como algo apresurado.'],
    ['Previous reviews', 'Reseñas anteriores'],
    ['Next reviews', 'Siguientes reseñas'],
    ['WELLNESS • CARE • BALANCE', 'BIENESTAR • CUIDADO • EQUILIBRIO'],
    ['Everyday wellness, elevated.', 'Bienestar diario, elevado.'],
    ['Shop best sellers', 'Ver más vendidos'],
    ['Explore categories', 'Explorar categorías'],
    ['Best sellers', 'Más vendidos'],
    ['View all', 'Ver todo'],
    ['Shop by need', 'Compra según lo que necesitas'],
    ['DAILY ROUTINES', 'RUTINAS DIARIAS'],
    ['Build a routine that feels easy.', 'Crea una rutina que se sienta fácil.'],
    ['Explore sets', 'Explorar sets'],
    ['Sleep & calm essentials', 'Esenciales para el sueño y la calma'],
    ['FREE SHIPPING OVER €50', 'ENVÍO GRATIS EN PEDIDOS SUPERIORES A 50 €'],
    ['SECURE CHECKOUT', 'PAGO SEGURO'],
    ['30-DAY RETURNS', 'DEVOLUCIONES EN 60 DÍAS'],
    ['EVERYDAY WELLNESS', 'BIENESTAR PARA CADA DÍA'],
    ['Summer Sale:', 'OFERTA DE VERANO:'],
    ['50% Off + Free Shipping', '50% DTO. + ENVÍO GRATIS'],
    ['HELP', 'AYUDA'],
    ['Contact', 'Contacto'],
    ['Shipping & Delivery', 'Envíos y entregas'],
    ['FAQs', 'Preguntas frecuentes'],
    ['Our Story', 'Nuestra historia'],
    ['Cart', 'Carrito'],
    ['Page not found', 'Página no encontrada'],
    ['Continue shopping', 'Seguir comprando'],
    ['Discover something new', 'Descubre algo nuevo'],
    ['Collections', 'Colecciones'],
    ['Submit', 'Enviar'],
    ['You may also like', 'También te puede gustar'],
    ['Opening soon', 'Muy pronto'],
    ['Sign up', 'Suscribirme'],
    ['Description', 'Descripción'],
    ['Shipping Information', 'Información de envío'],
    ['Returns & Refunds', 'Devoluciones y reembolsos'],
    ['LATEST FACEBOOK REVIES', 'ÚLTIMAS RESEÑAS DE FACEBOOK'],
    ['Watch these videos.', 'Mira estos vídeos.'],
    ['How Does It Work?', '¿Cómo funciona?'],
    ['How To Use', 'Cómo usarlo'],
    ['Why Choose Us?', '¿Por qué elegir VEONESS?'],
    ['Others Correctors', 'Otros correctores'],
    ['Special Offer On Now!', '¡Oferta especial disponible ahora!'],
    ['Choose Your Bundle Now 👉', 'Elige tu pack ahora 👉'],
    ['Worldwide Shipping', 'Envíos internacionales'],
    ['Expert Customer Support', 'Atención al cliente'],
    ['Free Shipping', 'Envío gratis'],
    ['Secure Checkout', 'Pago seguro'],
    ['90 Day Guarantee', 'Garantía de 90 días'],
    ['90-Day Money Back Guarantee', 'Garantía de devolución de 90 días']
  ]);

  const exactAttrs = new Map([
    ['Previous reviews', 'Reseñas anteriores'],
    ['Next reviews', 'Siguientes reseñas'],
    ['Accepted payment methods', 'Métodos de pago aceptados'],
    ['VEONESS Bunion Fix comparison chart', 'Tabla comparativa de VEONESS Bunion Fix']
  ]);

  function translateTextNode(node) {
    const original = node.nodeValue;
    if (!original || !original.trim()) return;
    const trimmed = original.trim();
    let translated = exactText.get(trimmed);
    if (!translated) {
      const match = trimmed.match(/^Go to review\s+(\d+)$/i);
      if (match) translated = `Ir a la reseña ${match[1]}`;
    }
    if (!translated) return;
    const start = original.match(/^\s*/)?.[0] || '';
    const end = original.match(/\s*$/)?.[0] || '';
    node.nodeValue = start + translated + end;
  }

  function translateElementAttributes(el) {
    ['aria-label', 'title', 'placeholder', 'alt'].forEach((attr) => {
      if (!el.hasAttribute?.(attr)) return;
      const current = el.getAttribute(attr);
      if (!current) return;
      let translated = exactAttrs.get(current) || exactText.get(current);
      if (!translated) {
        const match = current.match(/^Go to review\s+(\d+)$/i);
        if (match) translated = `Ir a la reseña ${match[1]}`;
      }
      if (translated) el.setAttribute(attr, translated);
    });
  }

  function translateSubtree(root = document.body) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT','STYLE','NOSCRIPT','TEXTAREA','CODE','PRE'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
    if (root.querySelectorAll) {
      root.querySelectorAll('[aria-label],[title],[placeholder],[alt]').forEach(translateElementAttributes);
    }
    if (root.nodeType === 1) translateElementAttributes(root);
    document.documentElement.lang = 'es';
  }

  function start() {
    translateSubtree(document.body);
    forceSpanishLocale();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
          else if (node.nodeType === Node.ELEMENT_NODE) translateSubtree(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
